import AddIcon from "@mui/icons-material/Add";
import { Alert, Button } from "@mui/material";
import { useState } from "react";
import { addCategory } from "../../api/products";
import useAuthToken from "../../hooks/getUserData";
import Modal from "../elements/Modal";
import CategoryForm from "./CategoryForm";

export function AddCategory({ onAddCategory, setMessage, setSnackbarOpen, fetchCategories }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = useAuthToken();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleSubmit = async (values) => {
    setError(null);
    setLoading(true);
    try {
      const res = await addCategory(token, values.name);

      if (res.ok) {
        setMessage("Category added successfully");
        setSnackbarOpen(true);
        handleClose();
        if (fetchCategories) {
          await fetchCategories();
        }
      } else {
        const errorData = await res.json().catch(() => ({}));
        setError(
          `Failed to add category: ${
            errorData.message || res.statusText || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error in addCategory API:", error);
      setError("Failed to add new category. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
      >
        Add Category
      </Button>

      <Modal
        open={open}
        modalTitle="Add New Category"
        handleClose={handleClose}
        width="sm"
      >
        {error && <Alert severity="error">{error}</Alert>}
        
        <CategoryForm
          onSubmit={handleSubmit}
          loading={loading}
        />
      </Modal>
    </>
  );
};

export default AddCategory;